import ConnectLayout from "@/pages/connect/layout";
import InstantVideoCallPage from "@/pages/connect/instant/video";
import InstantVoiceCallPage from "@/pages/connect/instant/voice";
import ScheduleVoiceCallPage from "@/pages/connect/schedule/voice";
import ScheduleVideoCallPage from "@/pages/connect/schedule/video";
import ErrorBoundary from "@/components/ErrorBoundry";
import MeetingEnd from "@/components/Meeting/MeetingEnd";

// Unified call component
import CallPage from "@/pages/calls/CallPage";

export const connectRoutes = {
  path: "/connect",
  element: <ConnectLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    { path: "/connect/instant/video", element: <InstantVideoCallPage /> },
    { path: "/connect/instant/voice", element: <InstantVoiceCallPage /> },
    {
      path: "/connect/schedule/video/:meetingId",
      element: <ScheduleVideoCallPage />,
    },
    {
      path: "/connect/schedule/voice/:meetingId",
      element: <ScheduleVoiceCallPage />,
    },
    {
      path: "/connect/meeting-end",
      element: <MeetingEnd />,
    },
  ],
};

// Unified call routes (no layout wrapper)
export const callRoutes = {
  path: "/calls",
  errorElement: <ErrorBoundary />,
  children: [
    { path: "/calls/:channel", element: <CallPage /> },
    // Keep legacy routes for backward compatibility
    { path: "/calls/video/:channel", element: <CallPage /> },
    { path: "/calls/voice/:channel", element: <CallPage /> },
  ],
};
